import { autorun, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { Alignment, Button, Classes, Dialog, FormGroup } from "@blueprintjs/core";
import { ISimplesTabela, newISimplesTabela } from "../../model";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import {
  BootstrapTable,
  SearchField,
  TableHeaderColumn,
} from "react-bootstrap-table";
import { toast } from "react-toastify";
import { TabelaSimplesStore } from "../../stores/admin/TabelaSimplesStore";
import { DefaultSelect, filterItens, renderItens } from "../utils/DefaultSelect";
import { handleGetSecao, handleGetTabela } from "../utils/TabelaSimplesUtils";

const numeral = require("numeral");

@observer
export class TabelaSimplesPage extends React.Component<{}, {}>{
  obs = observable({
    anexo: newISimplesTabela() as ISimplesTabela,
    secao: newISimplesTabela() as ISimplesTabela,
    tabela: newISimplesTabela() as ISimplesTabela,
    periodo: "" as string,
    open_duplicar: false as boolean,
    duplicar_anexo: newISimplesTabela() as ISimplesTabela,
    duplicar_secao: newISimplesTabela() as ISimplesTabela,
    duplicar_tabela: newISimplesTabela() as ISimplesTabela,
  })

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    AppStore.setTitle("Tabela Simples Nacional");

    autorun(async () => {

      TabelaSimplesStore.obs.tabelasimples = []

      if (this.obs.anexo.cod == "") {
        return
      }

      if (this.obs.secao.cod == "") {
        return
      }

      if (this.obs.tabela.cod == "") {
        return
      }

      this.handleBuscaTabelaSimples()
    })

  }

  async handleCreate() {

    if (this.obs.anexo.cod == "") {
      toast.warn("Selecione um anexo!", {});
      return
    }

    if (this.obs.secao.cod == "") {
      toast.warn("Selecione uma seção!", {});
      return
    }

    if (this.obs.tabela.cod == "") {
      toast.warn("Selecione uma tabela!", {});
      return
    }

    let params = {
      anexo: this.obs.anexo.cod,
      secao: this.obs.secao.cod,
      tabela: this.obs.tabela.cod,
      faixas: [
        { faixa: "1", inicial: 0, final: 0, aliquota: 0, valor_deduzir: 0 },
        { faixa: "2", inicial: 0, final: 0, aliquota: 0, valor_deduzir: 0 },
        { faixa: "3", inicial: 0, final: 0, aliquota: 0, valor_deduzir: 0 },
        { faixa: "4", inicial: 0, final: 0, aliquota: 0, valor_deduzir: 0 },
        { faixa: "5", inicial: 0, final: 0, aliquota: 0, valor_deduzir: 0 },
        { faixa: "6", inicial: 0, final: 0, aliquota: 0, valor_deduzir: 0 },
      ],
      percentuais: this.handleGetTabelas(this.obs.anexo.cod, this.obs.secao.cod)
    }

    let res = await TabelaSimplesStore.handleCreate(params)

    if (res) {

      this.handleBuscaTabelaSimples()

    }

  }

  getFor(percentuais) {

    for (var i = 2; i <= 6; i++) {
      var novoItem = Object.assign({}, percentuais[0])
      novoItem.faixa = i.toString()
      percentuais.push(novoItem)
    }

    return percentuais
  }

  handleGetTabelas(anexo, secao) {

    let percentuais = []

    switch (true) {

      case anexo == "1":
        percentuais = [{ faixa: "1", irpj: 0, csll: 0, cofins: 0, pis: 0, iss_cpp: 0, icms: 0 }]

        return (this.getFor(percentuais))

      case anexo == "2" && ["2.1", "2.2", "2.3"].includes(secao):
        percentuais = [{ faixa: "1", irpj: 0, csll: 0, cofins: 0, pis: 0, iss_cpp: 0, ipi: 0, icms: 0 }]

        return (this.getFor(percentuais))

      case anexo == "2" && ["2.4"].includes(secao):
        percentuais = [{ faixa: "1", irpj: 0, csll: 0, cofins: 0, pis: 0, iss_cpp: 0, ipi: 0, iss_anexo: 0 }]

        return (this.getFor(percentuais))

      case anexo == "2" && ["2.5"].includes(secao):
        percentuais = [{ faixa: "1", irpj: 0, csll: 0, cofins: 0, pis: 0, iss_cpp: 0, ipi: 0, iss: 0 }]

        return (this.getFor(percentuais))

      case anexo == "3" && ["3.1", "3.2", "3.3", "3.4", "3.6", "3.7", "3.8", "3.9", "3.10"].includes(secao):
        percentuais = [{ faixa: "1", irpj: 0, csll: 0, cofins: 0, pis: 0, iss_cpp: 0, iss: 0 }]

        return (this.getFor(percentuais))

      case anexo == "3" && ["3.5"].includes(secao):
        percentuais = [{ faixa: "1", irpj: 0, csll: 0, cofins: 0, pis: 0, iss_cpp: 0, icms_anexo: 0 }]

        return (this.getFor(percentuais))

      case anexo == "4":
        percentuais = [{ faixa: "1", irpj: 0, csll: 0, cofins: 0, pis: 0, iss: 0 }]

        return (this.getFor(percentuais))

      case anexo == "5":
        percentuais = [{ faixa: "1", irpj: 0, csll: 0, cofins: 0, pis: 0, iss_cpp: 0, iss: 0 }]

        return (this.getFor(percentuais))

      default:
        percentuais = [{ faixa: "1", irpj: 0, csll: 0, cofins: 0, pis: 0, iss_cpp: 0, icms: 0 }]

        return (this.getFor(percentuais))

    }

  }

  async handleBuscaTabelaSimples() {

    let params = {
      anexo: this.obs.anexo.cod,
      secao: this.obs.secao.cod,
      tabela: this.obs.tabela.cod
    }

    await TabelaSimplesStore.handleGetFaixas(params)
  }

  handleDuplicar() {

    this.obs.duplicar_anexo = newISimplesTabela()
    this.obs.duplicar_secao = newISimplesTabela()
    this.obs.duplicar_tabela = newISimplesTabela()

    this.obs.open_duplicar = true
  }

  handleChangeAnexo(e: any) {
    this.obs.anexo = e

    this.obs.secao = newISimplesTabela()
    this.obs.tabela = newISimplesTabela()

  }

  handleChangeSecao(e: any) {
    this.obs.secao = e

    this.obs.tabela = newISimplesTabela()
  }

  handleChangeDuplicarAnexo(e: any) {
    this.obs.duplicar_anexo = e

    this.obs.duplicar_secao = newISimplesTabela()
    this.obs.duplicar_tabela = newISimplesTabela()
  }

  handleChangeDuplicarSecao(e: any) {
    this.obs.duplicar_secao = e

    this.obs.duplicar_tabela = newISimplesTabela()
  }

  async handleSaveDuplicar() {

    if (this.obs.duplicar_anexo.cod == "") {
      toast.warn("Selecione um anexo!", {});
      return
    }

    if (this.obs.duplicar_secao.cod == "") {
      toast.warn("Selecione uma seção!", {});
      return
    }

    if (this.obs.duplicar_tabela.cod == "") {
      toast.warn("Selecione uma tabela!", {});
      return
    }

    this.obs.open_duplicar = false

    let params = {
      anexo: this.obs.duplicar_anexo.cod,
      secao: this.obs.duplicar_secao.cod,
      tabela: this.obs.duplicar_tabela.cod,
      faixas: TabelaSimplesStore.obs.tabelasimples.faixas,
      percentuais: TabelaSimplesStore.obs.tabelasimples.percentuais
    }

    let res = await TabelaSimplesStore.handleCreate(params)

    if (res) {

      this.obs.anexo = this.obs.duplicar_anexo
      this.obs.secao = this.obs.duplicar_secao
      this.obs.tabela = this.obs.duplicar_tabela

      this.handleBuscaTabelaSimples()

    }

  }

  render() {

    let faixas = TabelaSimplesStore.obs.tabelasimples ? TabelaSimplesStore.obs.tabelasimples.faixas?.map((x, index) => { x.tipo = "faixas"; x.index = index; return x }) || [] : []
    let percentuais = TabelaSimplesStore.obs.tabelasimples ? TabelaSimplesStore.obs.tabelasimples.percentuais?.map((x, index) => { x.tipo = "percentuais"; x.index = index; return x }) || [] : []

    let anexoText = this.obs.anexo.descricao != "" ? `${this.obs.anexo.descricao}`
      : "Selecione um Anexo";

    let secaoText = this.obs.secao.descricao != "" ? `${this.obs.secao.descricao}`
      : "Selecione uma Seção";

    let tabelaText = this.obs.tabela.descricao != "" ? `${this.obs.tabela.descricao}`
      : "Selecione uma Tabela";

    let anexoTextDuplicar = this.obs.duplicar_anexo.descricao != "" ? `${this.obs.duplicar_anexo.descricao}`
      : "Selecione um Anexo";

    let secaoTextDuplicar = this.obs.duplicar_secao.descricao != "" ? `${this.obs.duplicar_secao.descricao}`
      : "Selecione uma Seção";

    let tabelaTextDuplicar = this.obs.duplicar_tabela.descricao != "" ? `${this.obs.duplicar_tabela.descricao}`
      : "Selecione uma Tabela";

    let anexos = [
      { "cod": "1", "descricao": "Anexo I - Comércio" },
      { "cod": "2", "descricao": "Anexo II - Indústria" },
      { "cod": "3", "descricao": "Anexo III - Locação de Bens Móveis e Prestação de Serviços (não relacionados no § 5º-C do art. 18 da LC 155/2016)" },
      { "cod": "4", "descricao": "Anexo IV - Prestação de Serviços (relacionados no § 5º-C do art. 18 da LC 155/2016)" },
      { "cod": "5", "descricao": "Anexo V - Prestação de Serviços (relacionados no § 5º-1 do art. 18 da LC 155/2016)" }
    ]

    let secao = handleGetSecao(this.obs.anexo.cod)

    let tabela = handleGetTabela(this.obs.secao.cod)

    let secaoDuplicar = handleGetSecao(this.obs.duplicar_anexo.cod)

    let tabelaDuplicar = handleGetTabela(this.obs.duplicar_secao.cod)

    const onAfterSaveCellPercentual = async (row, cellName, cellValue) => {

      let valor = cellValue == "" ? "0" : cellValue.replace(",", ".")

      if (!(typeof parseFloat(valor) == "number")) {
        toast.error("São aceitos somente números", {});
        return false
      }

      let soma = parseFloat((parseFloat(row.cofins || 0) + parseFloat(row.csll || 0) + parseFloat(row.icms || 0) + parseFloat(row.irpj || 0) + parseFloat(row.iss_cpp || 0) + parseFloat(row.pis || 0) + parseFloat(row.ipi || 0) + parseFloat(row.iss_anexo || 0)).toFixed(4))

      if (soma > 100) {
        toast.error("A soma dos percentuais ultrapassa 100%", {});

        this.handleBuscaTabelaSimples()

        return false
      }

      let res = await TabelaSimplesStore.handleUpdateValue(row.index, row.tipo, TabelaSimplesStore.obs.tabelasimples._id, cellName, parseFloat(valor))

      if (res) {

        this.handleBuscaTabelaSimples()

      }

    }

    const onAfterSaveCellFaixa = async (row, cellName, cellValue) => {

      let valor = cellValue == "" ? "0" : cellValue.replace(",", ".")

      if (!(typeof parseFloat(valor) == "number")) {
        toast.error("São aceitos somente números", {});
        return false
      }

      let res = await TabelaSimplesStore.handleUpdateValue(row.index, row.tipo, TabelaSimplesStore.obs.tabelasimples._id, cellName, parseFloat(valor))

      if (res) {

        this.handleBuscaTabelaSimples()

      }

    }

    const percentualEdit = {
      type: "input",
    }

    const faixasEdit = {
      type: "input",
    }

    const cellEditFaixaProp = {
      mode: 'click',
      blurToSave: true,
      afterSaveCell: onAfterSaveCellFaixa
    };

    const cellEditPercentualProp = {
      mode: 'click',
      blurToSave: true,
      afterSaveCell: onAfterSaveCellPercentual
    };

    const valuesFormatter = (cell, row) => {
      return (
        <span>{numeral(parseFloat(cell)).format('0,0.00')}</span>
      );
    }

    const handleRenderTabela = () => {

      switch (true) {

        case this.obs.anexo.cod == "1":
          return (<>
            <BootstrapTable className="TabelaSimples" data={percentuais} cellEdit={cellEditPercentualProp}>
              <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="faixa" editable={false} width="10%">Faixa</TableHeaderColumn>
              <TableHeaderColumn dataField="irpj" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">IRPJ</TableHeaderColumn>
              <TableHeaderColumn dataField="csll" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">CSLL</TableHeaderColumn>
              <TableHeaderColumn dataField="cofins" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">COFINS</TableHeaderColumn>
              <TableHeaderColumn dataField="pis" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">PIS</TableHeaderColumn>
              <TableHeaderColumn dataField="iss_cpp" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ISS/CPP</TableHeaderColumn>
              <TableHeaderColumn dataField="icms" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ICMS</TableHeaderColumn>
            </BootstrapTable>
          </>)
        case this.obs.anexo.cod == "2" && ["2.1", "2.2", "2.3"].includes(this.obs.secao.cod):
          return (<>
            <BootstrapTable className="TabelaSimples" data={percentuais} cellEdit={cellEditPercentualProp}>
              <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="faixa" editable={false} width="10%">Faixa</TableHeaderColumn>
              <TableHeaderColumn dataField="irpj" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">IRPJ</TableHeaderColumn>
              <TableHeaderColumn dataField="csll" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">CSLL</TableHeaderColumn>
              <TableHeaderColumn dataField="cofins" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">COFINS</TableHeaderColumn>
              <TableHeaderColumn dataField="pis" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">PIS</TableHeaderColumn>
              <TableHeaderColumn dataField="iss_cpp" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ISS/CPP</TableHeaderColumn>
              <TableHeaderColumn dataField="ipi" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">IPI</TableHeaderColumn>
              <TableHeaderColumn dataField="icms" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ICMS</TableHeaderColumn>
            </BootstrapTable>
          </>)
        case this.obs.anexo.cod == "2" && ["2.4"].includes(this.obs.secao.cod):
          return (<>
            <BootstrapTable className="TabelaSimples" data={percentuais} cellEdit={cellEditPercentualProp}>
              <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="faixa" editable={false} width="10%">Faixa</TableHeaderColumn>
              <TableHeaderColumn dataField="irpj" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">IRPJ</TableHeaderColumn>
              <TableHeaderColumn dataField="csll" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">CSLL</TableHeaderColumn>
              <TableHeaderColumn dataField="cofins" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">COFINS</TableHeaderColumn>
              <TableHeaderColumn dataField="pis" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">PIS</TableHeaderColumn>
              <TableHeaderColumn dataField="iss_cpp" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ISS/CPP</TableHeaderColumn>
              <TableHeaderColumn dataField="ipi" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">IPI</TableHeaderColumn>
              <TableHeaderColumn dataField="iss_anexo" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ISS(Anexo III)</TableHeaderColumn>
            </BootstrapTable>
          </>)
        case this.obs.anexo.cod == "2" && ["2.5"].includes(this.obs.secao.cod):
          return (<>
            <BootstrapTable className="TabelaSimples" data={percentuais} cellEdit={cellEditPercentualProp}>
              <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="faixa" editable={false} width="10%">Faixa</TableHeaderColumn>
              <TableHeaderColumn dataField="irpj" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">IRPJ</TableHeaderColumn>
              <TableHeaderColumn dataField="csll" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">CSLL</TableHeaderColumn>
              <TableHeaderColumn dataField="cofins" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">COFINS</TableHeaderColumn>
              <TableHeaderColumn dataField="pis" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">PIS</TableHeaderColumn>
              <TableHeaderColumn dataField="iss_cpp" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ISS/CPP</TableHeaderColumn>
              <TableHeaderColumn dataField="ipi" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">IPI</TableHeaderColumn>
              <TableHeaderColumn dataField="iss" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ISS</TableHeaderColumn>
            </BootstrapTable>
          </>)
        case this.obs.anexo.cod == "3" && ["3.1", "3.2", "3.3", "3.4", "3.6", "3.7", "3.8", "3.9", "3.10"].includes(this.obs.secao.cod):
          return (<>
            <BootstrapTable className="TabelaSimples" data={percentuais} cellEdit={cellEditPercentualProp}>
              <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="faixa" editable={false} width="10%">Faixa</TableHeaderColumn>
              <TableHeaderColumn dataField="irpj" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">IRPJ</TableHeaderColumn>
              <TableHeaderColumn dataField="csll" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">CSLL</TableHeaderColumn>
              <TableHeaderColumn dataField="cofins" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">COFINS</TableHeaderColumn>
              <TableHeaderColumn dataField="pis" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">PIS</TableHeaderColumn>
              <TableHeaderColumn dataField="iss_cpp" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ISS/CPP</TableHeaderColumn>
              <TableHeaderColumn dataField="iss" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ISS</TableHeaderColumn>
            </BootstrapTable>
          </>)
        case this.obs.anexo.cod == "3" && ["3.5"].includes(this.obs.secao.cod):
          return (<>
            <BootstrapTable className="TabelaSimples" data={percentuais} cellEdit={cellEditPercentualProp}>
              <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="faixa" editable={false} width="10%">Faixa</TableHeaderColumn>
              <TableHeaderColumn dataField="irpj" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">IRPJ</TableHeaderColumn>
              <TableHeaderColumn dataField="csll" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">CSLL</TableHeaderColumn>
              <TableHeaderColumn dataField="cofins" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">COFINS</TableHeaderColumn>
              <TableHeaderColumn dataField="pis" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">PIS</TableHeaderColumn>
              <TableHeaderColumn dataField="iss_cpp" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ISS/CPP</TableHeaderColumn>
              <TableHeaderColumn dataField="icms" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ICMS(Anexo I)</TableHeaderColumn>
            </BootstrapTable>
          </>)
        case this.obs.anexo.cod == "4":
          return (<>
            <BootstrapTable className="TabelaSimples" data={percentuais} cellEdit={cellEditPercentualProp}>
              <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="faixa" editable={false} width="10%">Faixa</TableHeaderColumn>
              <TableHeaderColumn dataField="irpj" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">IRPJ</TableHeaderColumn>
              <TableHeaderColumn dataField="csll" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">CSLL</TableHeaderColumn>
              <TableHeaderColumn dataField="cofins" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">COFINS</TableHeaderColumn>
              <TableHeaderColumn dataField="pis" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">PIS</TableHeaderColumn>
              <TableHeaderColumn dataField="iss" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ISS</TableHeaderColumn>
            </BootstrapTable>
          </>)
        case this.obs.anexo.cod == "5":
          return (<>
            <BootstrapTable className="TabelaSimples" data={percentuais} cellEdit={cellEditPercentualProp}>
              <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="faixa" editable={false} width="10%">Faixa</TableHeaderColumn>
              <TableHeaderColumn dataField="irpj" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">IRPJ</TableHeaderColumn>
              <TableHeaderColumn dataField="csll" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">CSLL</TableHeaderColumn>
              <TableHeaderColumn dataField="cofins" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">COFINS</TableHeaderColumn>
              <TableHeaderColumn dataField="pis" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">PIS</TableHeaderColumn>
              <TableHeaderColumn dataField="iss_cpp" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ISS/CPP</TableHeaderColumn>
              <TableHeaderColumn dataField="iss" dataFormat={valuesFormatter} editable={percentualEdit} width="15%">ISS</TableHeaderColumn>
            </BootstrapTable>
          </>)
        default:
          return (<></>)
      }

    }

    return (
      <>
        <MDBRow>
          <MDBCol md="4">
            <FormGroup className="empresaSelect selectValues" label="Anexo">
              <DefaultSelect
                items={anexos}
                itemRenderer={renderItens}
                itemPredicate={filterItens}
                onItemSelect={(e: any) => this.handleChangeAnexo(e)}
                matchTargetWidth={true}
                inputProps={{ placeholder: "Filtrar um anexo" }}
              >
                <Button
                  text={anexoText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </DefaultSelect>
            </FormGroup>

            <FormGroup className="empresaSelect selectValues" label="Seção">
              <DefaultSelect
                items={secao}
                itemRenderer={renderItens}
                itemPredicate={filterItens}
                onItemSelect={(e: any) => this.handleChangeSecao(e)}
                matchTargetWidth={true}
                inputProps={{ placeholder: "Filtrar uma seção" }}
              >
                <Button
                  text={secaoText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                  disabled={this.obs.anexo.cod == "" ? true : false}
                />
              </DefaultSelect>
            </FormGroup>

            <FormGroup className="empresaSelect selectValues" label="Tabela">
              <DefaultSelect
                items={tabela}
                itemRenderer={renderItens}
                itemPredicate={filterItens}
                onItemSelect={(e: any) => this.obs.tabela = e}
                matchTargetWidth={true}
                inputProps={{ placeholder: "Filtrar uma tabela" }}
              >
                <Button
                  text={tabelaText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                  disabled={this.obs.anexo.cod != "" && this.obs.secao.cod != "" ? false : true}
                />
              </DefaultSelect>
            </FormGroup>

            {!TabelaSimplesStore.obs.tabelasimples._id && this.obs.anexo.cod != "" && this.obs.secao.cod != "" && this.obs.tabela.cod != "" ?
              <MDBBtn
                className="btnDefault btnBuscarNfe"
                style={{ float: "right" }}
                onClick={() => this.handleCreate()}
              >
                Criar
              </MDBBtn>
              : <></>}

          </MDBCol>

          {TabelaSimplesStore.obs.tabelasimples._id ?
            <MDBCol md="12">
              <MDBBtn
                className="btnDefault btnBuscarNfe"
                style={{ float: "right" }}
                onClick={() => this.handleDuplicar()}
              >
                Duplicar
              </MDBBtn>
            </MDBCol>
            : <></>}

          <MDBCol md="12">
            {TabelaSimplesStore.obs.tabelasimples._id ?
              <>
                <FormGroup label="Faixas">
                  <BootstrapTable className="TabelaSimples" data={faixas} cellEdit={cellEditFaixaProp}>
                    <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                    <TableHeaderColumn dataField="faixa" editable={false} width="10%">Faixa</TableHeaderColumn>
                    <TableHeaderColumn dataField="inicial" dataFormat={valuesFormatter} editable={faixasEdit} width="15%">Inicial</TableHeaderColumn>
                    <TableHeaderColumn dataField="final" dataFormat={valuesFormatter} editable={faixasEdit} width="15%">Final</TableHeaderColumn>
                    <TableHeaderColumn dataField="aliquota" dataFormat={valuesFormatter} editable={faixasEdit} width="15%">Alíquota</TableHeaderColumn>
                    <TableHeaderColumn dataField="valor_deduzir" dataFormat={valuesFormatter} editable={faixasEdit} width="15%">Valor a deduzir</TableHeaderColumn>
                  </BootstrapTable>
                </FormGroup>

                <FormGroup label="Percentual de repartição dos tributos">
                  {handleRenderTabela()}
                </FormGroup>
              </>
              : <></>}
          </MDBCol>

        </MDBRow >

        <div style={{ marginBottom: 120 }} />

        <Dialog
          isOpen={this.obs.open_duplicar}
          title="Duplicar"
          onClose={() => this.obs.open_duplicar = false}
        >
          <div className={Classes.DIALOG_BODY}>
            <FormGroup className="empresaSelect selectValues" label="Anexo">
              <DefaultSelect
                items={anexos}
                itemRenderer={renderItens}
                itemPredicate={filterItens}
                onItemSelect={(e: any) => this.handleChangeDuplicarAnexo(e)}
                matchTargetWidth={true}
                inputProps={{ placeholder: "Filtrar um anexo" }}
              >
                <Button
                  text={anexoTextDuplicar}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </DefaultSelect>
            </FormGroup>

            <FormGroup className="empresaSelect selectValues" label="Seção">
              <DefaultSelect
                items={secaoDuplicar}
                itemRenderer={renderItens}
                itemPredicate={filterItens}
                onItemSelect={(e: any) => this.handleChangeDuplicarSecao(e)}
                matchTargetWidth={true}
                inputProps={{ placeholder: "Filtrar uma seção" }}
              >
                <Button
                  text={secaoTextDuplicar}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                  disabled={this.obs.duplicar_anexo.cod == "" ? true : false}
                />
              </DefaultSelect>
            </FormGroup>

            <FormGroup className="empresaSelect selectValues" label="Tabela">
              <DefaultSelect
                items={tabelaDuplicar}
                itemRenderer={renderItens}
                itemPredicate={filterItens}
                onItemSelect={(e: any) => this.obs.duplicar_tabela = e}
                matchTargetWidth={true}
                inputProps={{ placeholder: "Filtrar uma tabela" }}
              >
                <Button
                  text={tabelaTextDuplicar}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                  disabled={this.obs.duplicar_anexo.cod != "" && this.obs.duplicar_secao.cod != "" ? false : true}
                />
              </DefaultSelect>
            </FormGroup>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Salvar" intent="primary" onClick={() => this.handleSaveDuplicar()} />
              <Button text="Cancelar" onClick={() => this.obs.open_duplicar = false} />
            </div>
          </div>
        </Dialog>
      </>
    );
  }
}
